document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.specs-accordion-header').forEach(header => {
    header.addEventListener('click', function() {
      const panel = document.querySelector(`#${header.dataset.target}`);
      const toggle = header.querySelector('.specs-toggle');

      if (header.classList.contains('specs-active')) {
        header.classList.remove('specs-active');
        panel.classList.remove('open');
        toggle.classList.remove('specs-active');
      } else {
        // Close all other panels
        document.querySelectorAll('.specs-accordion-header').forEach(otherHeader => {
          otherHeader.classList.remove('specs-active');
          const otherPanel = document.querySelector(`#${otherHeader.dataset.target}`);
          otherPanel.classList.remove('open');
          otherHeader.querySelector('.specs-toggle').classList.remove('specs-active');
        });

        // Open the clicked panel
        header.classList.add('specs-active');
        panel.classList.add('open');
        toggle.classList.add('specs-active');
      }
    });
  });
});





async function applySellingPlan({ lineKey, sellingPlanId, quantity = 1, btn = null }) {
  if (!lineKey || !sellingPlanId) return;

  const root = window.Shopify?.routes?.root || "/";

  if (btn) {
    btn.classList.add("loading_tr");
    btn.disabled = true;
  }

  try {
    // Get the current cart so we can convert line item key -> line number
    const cartRes = await fetch(`${root}cart.js`);
    const cart = await cartRes.json();

    const lineIndex = cart.items.findIndex(item => item.key === lineKey);

    if (lineIndex === -1) {
      throw new Error(`Line item not found for key: ${lineKey}`);
    }

    const response = await fetch(`${root}cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        line: lineIndex + 1,
        quantity: Number(quantity) || 1,
        selling_plan: Number(sellingPlanId)
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.description || data?.message || `Cart change failed: ${response.status}`);
    }

    const cartDrawerSlide = document.querySelector("#cart-drawer");
    if (cartDrawerSlide && cartDrawerSlide._onCartRefresh) {
      await cartDrawerSlide._onCartRefresh();
      cartDrawerSlide.show();
    }

    if (btn) btn.style.display = "none";
  } catch (error) {
    console.error("Failed to apply selling plan:", error);
  } finally {
    if (btn) {
      btn.classList.remove("loading_tr");
      btn.disabled = false;
    }
  }
}

document.addEventListener("click", function (e) {
  const btn = e.target.closest(".subscribe-btn");
  if (!btn) return;

  e.preventDefault();

  applySellingPlan({
    lineKey: btn.dataset.lineKey,
    sellingPlanId: btn.dataset.sellingPlanId,
    quantity: btn.dataset.quantity,
    btn
  });
});





(function() {
  

  async function getCart() {
    const res = await fetch(`/cart.js?ts=${Date.now()}`, { credentials: 'same-origin' });
    return res.json();
  }

  async function removeByKey(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function getIdsFromDOM() {
    const container = document.querySelector('.package-protection');
    if (!container) return null;
    return {
      productId: parseInt(container.dataset.shipProductId, 10),
      variantId: parseInt(container.dataset.shipVariantId, 10),
      checkbox: container.querySelector('.shippingProtectionToggle')
    };
  }

  function findProtection(cart, productId, variantId) {
    // Prefer variant match (more precise), fallback to product match
    return cart.items.find(i => (variantId && i.variant_id === variantId) || i.product_id === productId);
  }

  function isFreeGiftLineItem(item) {
    return item && item.properties && item.properties._free_gift === 'true';
  }

  function getParentVariantIdFromGift(item) {
    return item && item.properties ? String(item.properties._parent_variant_id || '') : '';
  }

  function getParentSellingPlanIdFromGift(item) {
    return item && item.properties ? String(item.properties._parent_selling_plan_id || '') : '';
  }

  function getSellingPlanIdFromLineItem(item) {
    if (!item || !item.selling_plan_allocation) return '';
    return String(item.selling_plan_allocation.selling_plan.id || '');
  }

  function hasMatchingParentLine(cartItems, giftItem) {
    const parentVariantId = getParentVariantIdFromGift(giftItem);
    const parentSellingPlanId = getParentSellingPlanIdFromGift(giftItem);

    if (!parentVariantId) return false;

    return cartItems.some(item => {
      if (isFreeGiftLineItem(item) || item.quantity <= 0) return false;
      if (String(item.variant_id) !== parentVariantId) return false;
      return getSellingPlanIdFromLineItem(item) === parentSellingPlanId;
    });
  }

  let syncFreeGiftsLock = false;
  async function syncFreeGiftsWithCart() {
    if (syncFreeGiftsLock) return;

    syncFreeGiftsLock = true;
    try {
      const cart = await getCart();

      const giftsToRemove = cart.items.filter(item => {
        if (!isFreeGiftLineItem(item)) return false;
        return !hasMatchingParentLine(cart.items, item);
      });

      for (const gift of giftsToRemove) {
        await removeByKey(gift.key);
      }

      const refreshedCart = giftsToRemove.length ? await getCart() : cart;
      const giftsToNormalize = refreshedCart.items.filter(
        item => isFreeGiftLineItem(item) && item.quantity > 1
      );

      for (const gift of giftsToNormalize) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: gift.key, quantity: 1 })
        });
      }

      if (giftsToRemove.length || giftsToNormalize.length) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (err) {
      console.warn('syncFreeGiftsWithCart failed:', err);
    } finally {
      syncFreeGiftsLock = false;
    }
  }

  let ensureLock = false;
  async function ensureProtectionNotAlone() {
    if (ensureLock) return;
    const ids = getIdsFromDOM();
    if (!ids) return;

    ensureLock = true;
    try {
      const cart = await getCart();
      const protection = findProtection(cart, ids.productId, ids.variantId);
      if (!protection) { ensureLock = false; return; }

      const nonProtectionCount = cart.items.filter(i =>
        !((ids.variantId && i.variant_id === ids.variantId) || i.product_id === ids.productId)
      ).length;

      if (nonProtectionCount === 0) {
        await removeByKey(protection.key);
        // Best-effort UI sync
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        // If there’s a checkbox, reflect state
        if (ids.checkbox) ids.checkbox.checked = false;
      }
    } catch (err) {
      console.warn('ensureProtectionNotAlone failed:', err);
    } finally {
      ensureLock = false;
    }
  }



  async function handleProtectionChange(e) {
    const checkbox = e.target;
    const container = checkbox.closest('.package-protection');
    if (!container) return;

    const productId = parseInt(container.dataset.shipProductId, 10);
    const variantId = parseInt(container.dataset.shipVariantId, 10);
    const isChecked = checkbox.checked;

    try {
      if (isChecked) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
      } else {
        const cart = await getCart();
        const lineItem = findProtection(cart, productId, variantId);
        if (lineItem) await removeByKey(lineItem.key);
      }

      await ensureProtectionNotAlone();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (err) {
      console.error('Shipping protection toggle failed:', err);
      checkbox.checked = !isChecked;
    }
  }


  const _origFetch = window.fetch;
  window.fetch = async function(input, init) {
    const res = await _origFetch(input, init);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)\.js(\?|$)/.test(url)) {
        // Run after the cart endpoint finishes
        Promise.resolve().then(() => {
          syncFreeGiftsWithCart();
          ensureProtectionNotAlone();
        });
      }
    } catch (e) {
      // noop
    }
    return res;
  };

 

  let lastCheck = 0;
  setInterval(() => {
    const now = Date.now();
    if (now - lastCheck < 1500) return;
    lastCheck = now;
    syncFreeGiftsWithCart();
    ensureProtectionNotAlone();
  }, 2000);


  document.addEventListener('change', function(e) {
    if (e.target && e.target.classList.contains('shippingProtectionToggle')) {
      handleProtectionChange(e);
    }
  });

  document.addEventListener('vsn:sync-free-gifts', function() {
    syncFreeGiftsWithCart();
  });

  document.addEventListener('cart:change', function() {
    syncFreeGiftsWithCart();
  });

  document.addEventListener('cart:refresh', function() {
    syncFreeGiftsWithCart();
  });

  // Initial pass on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      syncFreeGiftsWithCart();
      ensureProtectionNotAlone();
    });
  } else {
    syncFreeGiftsWithCart();
    ensureProtectionNotAlone();
  }

})();






  